import { Briefcase, User, Target, Rocket, Construction } from "lucide-react";

export const aboutContent = [
  {
    icon: Briefcase,
    header: "What I'm Doing Right Now",
    description:
      "I'm currently at Climate Action Data Trust (CADTrust), where my role sits at the intersection of data engineering and product management. CADTrust is a neutral, non-profit platform built to bring transparency and integrity to global carbon markets. It's a unique organisation, founded by the World Bank, the Government of Singapore, and IETA, which gives it a culture that blends startup flexibility with corporate structure. I work a lot in the evenings, collaborating with teams and partners across Europe and the US.",
  },
  {
    icon: User,
    header: "What is This Website About",
    description:
      "I want to express my ideas and projects that I have done. I approach both my full-time job and hobbies with full dedication, which has led me to pursue various interests beyond coding, including photography, coffee brewing, basketball, volunteering or sustainability initiatives.",
  },
  {
    icon: Target,
    header: "What is the Purpose",
    description:
      "I want to have engaging conversations with people who have the same interests with me and open up more opportunities and collaborations. I also feel that it's difficult to say everything about me to my friends, so in this website people may know 50-60% of myself. A bonus point is that I'll be happy if someone gets inspired.",
  },
  {
    icon: Rocket,
    header: "What I Am Aiming in the Near Future",
    description:
      "Besides my fulltime job as a tech oriented person, I am also starting my carbon credit project at a coffee farm in Indonesia, doing freelance photography for hotels, couples, and friends, and building more personal coding projects and AI tools. I'm deliberate about sharpening the skills that matter — product engineering, AI development, DevRel, and forward deployed engineering — across sectors I care about: carbon markets, tech, and finance.",
  },
  {
    icon: Construction,
    header: "Work in Progress",
    description:
      "I will have more in depth details about book reviews, more software engineering documentations, and a better website interface.",
  },
];
